import React, { useState, useContext, useEffect } from "react";


const PageHeader = (props) => {
const headerText = props.Text;

return (<div style={{fontSize:'35px', textTransform:'capitalize',letterSpacing:'2px', color:'#888888'}}>{headerText}</div>)
};
export default PageHeader;
